import React from 'react';
import { Link, useLoaderData } from '@remix-run/react';
import type { loader as homeLoader } from '~/routes/_app._index';
import { ReactComponent as ArrowRight } from '@rocco/icons/svg/arrow/arrow-right.svg';
import {
    formatNumberWithCommas,
    roundToNearest,
} from '@rocco/utils/format-number';
import { Button as RoccoButton } from '@rocco/components/button';
import { HomePageFeaturedCategories } from '@ui-rocco/pages/home-page/HomePageFeaturedCategories';
import { useCTAHandlers } from '~/ui-rocco/hooks/use-home-cta-actions';

export const HomePageProfessionals = () => {
    const { professionalSection, appDisplayMode } =
        useLoaderData<typeof homeLoader>();
    const { handleCTAClick } = useCTAHandlers('HomePageProfessionals');

    return (
        <section className="py-20 md:py-[10.25rem] md:pb-[7.2rem]">
            <div className="flex flex-col items-center justify-center gap-6 px-4 pb-8 md:gap-12 md:px-0 md:pb-24">
                <h3 className="gap-10.5 text-center text-3xl leading-[127.78%] tracking-[-0.125rem] md:flex md:text-20 md:leading-[100%]">
                    <span>{`${professionalSection.prefixTitle} `}</span>
                    <span className="mx-2 inline-block rounded-full border-2 border-black px-4 py-0.5 leading-[100%] md:mx-0 md:px-7.5">{`${formatNumberWithCommas(roundToNearest(professionalSection.count))}+`}</span>
                    <span>{`${professionalSection.suffixTitle}`}</span>
                </h3>
                <p className="px-6 py-2.5 text-center text-base text-gray-700 md:max-w-[46.875rem] md:px-0 md:text-5 md:leading-[130%] md:tracking-[0.025rem]">
                    {professionalSection.description}
                </p>
            </div>
            <HomePageFeaturedCategories
                categories={professionalSection.categories}
                title={professionalSection.categorySliderTitle ?? ''}
                appDisplayMode={appDisplayMode}
                section="HomePageProfessionals"
            />
            <div className="mt-12 text-center md:mt-[6.7rem]">
                <RoccoButton color="primary" asChild>
                    <Link
                        to={
                            professionalSection.CTAButton?.link ??
                            '/professionals'
                        }
                        onClick={() => handleCTAClick()}
                    >
                        {professionalSection.CTAButton?.text}
                        <ArrowRight className="ml-1.5 w-4" />
                    </Link>
                </RoccoButton>
            </div>
        </section>
    );
};
